export default {
  maptiler: {
    attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    url:"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  },
};
